import React from 'react'

const ConflictUpload = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="10" fill="#F2F3F5" />
      <mask
        id="mask0_1822_26704"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="24"
        height="24"
      >
        <rect x="10" y="10" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1822_26704)">
        <path
          d="M16 30C15.45 30 14.9793 29.8043 14.588 29.413C14.196 29.021 14 28.55 14 28V25H16V28H28V25H30V28C30 28.55 29.8043 29.021 29.413 29.413C29.021 29.8043 28.55 30 28 30H16ZM21 26V17.85L18.4 20.45L17 19L22 14L27 19L25.6 20.45L23 17.85V26H21Z"
          fill="#B3B7C1"
        />
      </g>
    </svg>
  )
}

export default ConflictUpload
